import { Api as api } from "../../api";

const prefix = "/transport-operation";

export interface DriverTransportOrderItem {
  id: string;
  wo_number: string;
  customer_name: string;
  date: string;
  fund_transferred: number;
  status: string;
}

export interface DriverTransportOrderPagination {
  current_page?: number;
  have_next_page?: boolean;
  have_previous_page?: boolean;
  limit?: number;
  total?: number;
  total_page?: number;
}

export interface GetDriverTransportOrderHistoryResponse {
  items?: DriverTransportOrderItem[];
  meta?: DriverTransportOrderPagination;
}

export interface GetDriverTransportOrderHistoryArg {
  driverId: string;
  page?: number;
  limit?: number;
}

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getDriverTransportOrderHistory: build.query<
      GetDriverTransportOrderHistoryResponse,
      GetDriverTransportOrderHistoryArg
    >({
      query: ({ driverId, page = 1, limit = 10 }) => ({
        url: `${prefix}/tms/api/v1/transport-order/driver/${driverId}/history`,
        params: {
          page,
          limit,
        },
      }),
      providesTags: (_result, _error, arg) => [
        { type: "Driver" as const, id: `TO_HISTORY_${arg.driverId}` },
      ],
    }),
  }),
  overrideExisting: false,
});

export { injectedRtkApi as transportOrderApi };
export const { useGetDriverTransportOrderHistoryQuery } = injectedRtkApi;
